




















import Vue from 'vue'
export default Vue.extend({
props : {
        version : {
        type : String,
        default : "Version de l'application : ... "
    },
}
})
